import * as React from "react";
import type { SVGProps } from "react";
const SvgMagneticIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="magnetic_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M775.296 124.16a38.827 38.827 0 1 0-77.568 0v155.093a38.827 38.827 0 0 0 43.605 38.528l111.574-13.952v111.19a38.827 38.827 0 1 0 77.568 0V259.883a38.827 38.827 0 0 0-43.606-38.486L775.296 235.35V124.117zM620.459 337.835 417.067 134.443 182.4 369.109a331.904 331.904 0 0 0 469.333 469.419l234.71-234.71-203.393-203.39-234.666 234.665a44.245 44.245 0 1 1-62.592-62.549l234.667-234.71zM244.992 431.7l172.075-172.074 78.25 78.208L323.2 509.952a132.779 132.779 0 1 0 187.733 187.733l172.118-172.117 78.25 78.25-172.117 172.118a243.413 243.413 0 0 1-344.235-344.235z"
    />
  </svg>
);
export default SvgMagneticIcon;
